module.exports = __webpack_public_path__ + "img/banner_shui.8c738845.png";